import { CallbackObject } from 'api/core/get-page-function';
import { instance } from 'api/core';

export const unassignTeamFromCircuit = async (
    circuitId: string,
    callback: CallbackObject<void>
) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        await instance.patch(`/picking/circuits/${circuitId}/team/unassign`, {}, config);
        callback.success();
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
